export default "__VITE_ASSET__berjiitw__"